import { render, staticRenderFns } from "./PropertyAttribute.vue?vue&type=template&id=14086207&scoped=true"
import script from "./PropertyAttribute.vue?vue&type=script&lang=js"
export * from "./PropertyAttribute.vue?vue&type=script&lang=js"
import style0 from "./PropertyAttribute.vue?vue&type=style&index=0&id=14086207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14086207",
  null
  
)

export default component.exports